import React from "react";
import Table from "react-bootstrap/Table";
import {
  getInvoiceByPeriodAction,
  getInvoiceByid,
} from "../../../actions/BillingActions";
import { connect } from "react-redux";

/**
 * @desc created pure component for open delete prompt
 */
class InvoiceDetailsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      invoiceDetails: [],
      showLoader: false,
    };
  }
  componentDidMount() {
    // console.log("userId", this.props.userId);
    // console.log("invoicePeriod", this.props.invoicePeriod);

    if (this.props.invoiceId) {
      // call invoice by id api.
      this.getinvoicebyinvoiceid(this.props.invoiceId);
    } else {
      this.getInvoiceDetails(
        this.props.userId,
        this.props.invoicePeriod,
        this.props.isCurrentInvoice
      );
    }
  }

  /**this is because , getinvoicedetail update the invoice , then we want to fetch the invoice */
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.childComponentRander !== this.props.childComponentRander) {
      this.getInvoiceDetails(
        this.props.userId,
        this.props.invoicePeriod,
        this.props.isCurrentInvoice
      );
    }
  }

  getInvoiceDetails = (userId, invoicePeriod, isCurrentInvoice) => {
    let data = {
      userId: userId,
      invoicePeriod: invoicePeriod,
      isCurrentInvoice: isCurrentInvoice,
    };

    this.setState({
      showLoader: true,
    });
    this.props
      .getInvoiceByPeriodAction(data)
      .then((res) => {
        let invoiceData = res.data;
        this.setState({
          invoiceDetails: invoiceData,
          showLoader: false,
        });
        //setRerander(!Rerander);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getinvoicebyinvoiceid = (id) => {
    this.setState({
      showLoader: true,
    });
    this.props
      .getInvoiceByid(id)
      .then((res) => {
        let invoiceData = res.data;
        this.setState({
          invoiceDetails: invoiceData,
          showLoader: false,
        });
        //setRerander(!Rerander);
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <Table className="add-buyer-table update-render">
            <thead>
              <tr>
                <th>Reference</th>
                <th>Total Count</th>
                <th>Free Count</th>
                <th>Billable Count</th>
                <th>Charge</th>
                <td>
                  {" "}
                  <span>&nbsp;</span>{" "}
                </td>
                <th>Total Charges</th>
                <th>
                  {" "}
                  <span>&nbsp;</span>{" "}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.invoiceDetails &&
                this.state.invoiceDetails.billingItems &&
                this.state.invoiceDetails.billingItems.length > 0 &&
                this.state.invoiceDetails.billingItems.map((item, index) => {
                  return (
                    <>
                      {item && item.isActive === true ? (
                        <tr key={index}>
                          <td>{item.billingItemDesc}</td>
                          <td>{item.totalCount ? item.totalCount : "0"}</td>
                          <td>{item.freeCount}</td>
                          <td>{item.billableCount}</td>
                          <td>${item.perCharge.toFixed(2)}</td>
                          <td>
                            {" "}
                            <span>&nbsp;</span>{" "}
                          </td>
                          <td>${item.total.toFixed(2)}</td>
                          <td>
                            {" "}
                            <span>&nbsp;</span>{" "}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
              <tr className="border-top-bold">
                <td />
                <td />
                <td />
                <td colSpan={2} className="font-bold">
                  Total
                </td>
                <td>
                  {" "}
                  <span>&nbsp;</span>{" "}
                </td>
                <td className="font-bold">
                  {this.state.invoiceDetails &&
                  this.state.invoiceDetails.invoiceAmount
                    ? "$" + this.state.invoiceDetails.invoiceAmount.toFixed(2)
                    : "$" + "0.00"}
                </td>
                <td>
                  {" "}
                  <span>&nbsp;</span>{" "}
                </td>
              </tr>
              {this.state.invoiceDetails &&
                this.state.invoiceDetails.additionalCharges > 0 && (
                  <tr>
                    <td />
                    <td />
                    <td />
                    <td colSpan={2} className="font-bold">
                      Additional charges
                    </td>
                    <td>
                      {" "}
                      <span>+</span>{" "}
                    </td>
                    <td className="font-bold">
                      {this.state.invoiceDetails &&
                      this.state.invoiceDetails.additionalCharges
                        ? "$" +
                          this.state.invoiceDetails.additionalCharges.toFixed(2)
                        : "$" + "0.00"}
                    </td>
                    <td>
                      {" "}
                      <span>&nbsp;</span>{" "}
                    </td>
                  </tr>
                )}
              {this.state.invoiceDetails &&
                this.state.invoiceDetails.credits > 0 && (
                  <tr>
                    <td />
                    <td />
                    <td />
                    <td colSpan={2} className="font-bold">
                      Credit
                    </td>
                    <td>
                      {" "}
                      <span>-</span>{" "}
                    </td>
                    <td className="font-bold">
                      {this.state.invoiceDetails &&
                      this.state.invoiceDetails.credits
                        ? "$" + this.state.invoiceDetails.credits.toFixed(2)
                        : "$" + "0.00"}
                    </td>
                    <td>
                      {" "}
                      <span>&nbsp;</span>{" "}
                    </td>
                  </tr>
                )}
              {this.state.invoiceDetails &&
                this.state.invoiceDetails.discount > 0 && (
                  <tr>
                    <td />
                    <td />
                    <td />
                    <td colSpan={2} className="font-bold">
                      Discount
                    </td>
                    <td>
                      {" "}
                      <span>-</span>{" "}
                    </td>
                    <td className="font-bold">
                      {this.state.invoiceDetails &&
                      this.state.invoiceDetails.discount
                        ? "$" + this.state.invoiceDetails.discount.toFixed(2)
                        : "$" + "0.00"}
                    </td>
                    <td>
                      {" "}
                      <span>&nbsp;</span>{" "}
                    </td>
                  </tr>
                )}
              <tr className="border-top-bottom-bold">
                <td />
                <td />
                <td />
                <td colSpan={2} className="font-bold">
                  Final Amount
                </td>
                <td>
                  {" "}
                  <span>&nbsp;</span>{" "}
                </td>
                <td className="font-bold">
                  {this.state.invoiceDetails &&
                  this.state.invoiceDetails.finalAmount
                    ? "$" + this.state.invoiceDetails.finalAmount.toFixed(2)
                    : "$" + "0.00"}
                </td>
                <td>
                  {" "}
                  <span>&nbsp;</span>{" "}
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getInvoiceByPeriodAction,
    getInvoiceByid,
  }
)(InvoiceDetailsTable);
